
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/genre/[id]",
      function () {
        return require("private-next-pages/[country]/[language]/genre/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/genre/[id]"])
      });
    }
  